import apigClient from "@/services/aws/apigClient"
import AWSClockSkewHandler from "@/services/aws/AWSClockSkewHandler"

// let client = null
const getClient = (credentials) => {
  // if(!client) {
    let client = apigClient.newClient({
        accessKey: credentials.accessKey,
        secretKey: credentials.secretKey,
        sessionToken: credentials.sessionToken,
        region: 'us-west-2',
        defaultContentType: 'application/json',
        defaultAcceptType: 'application/json'
    },
      process.env.VUE_APP_API_URL)
  // }
  return client
}


class Api {
  async getAccount(credentials) {
    let e
    const result = await AWSClockSkewHandler.handleClockSkew(() => {
      const client = getClient(credentials)
      return client.accountPost({}, {
        idToken: credentials.idToken
      })
    }).catch(err => {
      e = err
    })
    if(e) throw e

    return result
  }

  async createStripeBillingUrl(credentials) {
    let e
    const result = await AWSClockSkewHandler.handleClockSkew(() => {
      const client = getClient(credentials)
      return client.stripeGet({})
    }).catch(err => {
      e = err
    })
    if(e) throw e

    return result
  }

  async createStripeCheckoutUrl(credentials, requestBody) {
    let e
    const result = await AWSClockSkewHandler.handleClockSkew(() => {
      const client = getClient(credentials)
      return client.stripeCheckoutPost({}, requestBody)
    }).catch(err => {
      e = err
    })
    if(e) throw e

    return result
  }

  async deleteVideo(credentials, videoId) {
    let e
    const result = await AWSClockSkewHandler.handleClockSkew(() => {
      const client = getClient(credentials)
      return client.videoDelete({}, {
        videoId: videoId
      })
    }).catch(err => {
      e = err
    })
    if(e) throw e

    return result
  }

  async getVideos(credentials) {
    let e
    const result = await AWSClockSkewHandler.handleClockSkew(() => {
      const client = getClient(credentials)
      return client.videosGet()
    }).catch(err => {
      e = err
    })
    if(e) throw e

    return result
  }

  async addToTeam(credentials, request) {
    let e
    const result = await AWSClockSkewHandler.handleClockSkew(() => {
      const client = getClient(credentials)
      return client.teamPost({}, request)
    }).catch(err => {
      e = err
    })
    if(e) throw e

    return result
  }

  async removeFromTeam(credentials, request) {
    let e
    const result = await AWSClockSkewHandler.handleClockSkew(() => {
      const client = getClient(credentials)
      return client.teamDelete({}, request)
    }).catch(err => {
      e = err
    })
    if(e) throw e

    return result
  }

  async removeSelfFromTeam(credentials, request) {
    let e
    const result = await AWSClockSkewHandler.handleClockSkew(() => {
      const client = getClient(credentials)
      return client.accountTeamDelete({}, request)
    }).catch(err => {
      e = err
    })
    if(e) throw e

    return result
  }

  async updateProfile(credentials, requestBody) {
    let e
    const result = await AWSClockSkewHandler.handleClockSkew(() => {
      const client = getClient(credentials)
      return client.profilePut({}, requestBody)
    }).catch(err => {
      e = err
    })
    if(e) throw e

    return result
  }

  async updateProfilePhoto(credentials, requestBody) {
    let e
    const result = await AWSClockSkewHandler.handleClockSkew(() => {
      const client = getClient(credentials)
      return client.profilePhotoPut({}, requestBody)
    }).catch(err => {
      e = err
    })
    if(e) throw e

    return result
  }
}

export default (new Api())